/* eslint no-shadow:0 */
import axios from 'axios';

const data = {
  qoute: {},
  renewalClient: {},
  dpRenewal: {},
};
const getters = {
  fetchQoute: (state) => state.qoute,
  renewalClient: (state) => state.renewalClient,
  dpRenewal: (state) => state.dpRenewal,
};

const mutations = {
  updateQuotation(state, payload) {
    state.qoute = payload;
  },
  updateRenewalClient(state, payload) {
    state.renewalClient = payload;
  },
  setdpRenewal(state, data) {
    state.dpRenewal = { ...state.dpRenewal, ...data };
  },
  cleardpRenewal(state) {
    state.dpRenewal = {};
  },
};
const actions = {
  fetchRenewalClient: async (context, id) => {
    await axios.get(`/customer/gis/clients/renewalClients?batchNo=${id}`).then(async (response) => {
      context.commit('updateRenewalClient', response.data.object);
    });
  },
  fetchQuotation: async (context, id) => {
    await axios.get(`/customer/quotation?batchNo=${id}`).then((response) => {
      if (response.data.success) {
        context.commit('updateQuotation', response.data.data);
      }
    });
  },
};

export default {
  namespaced: true,
  state: data,
  getters,
  actions,
  mutations,
};
